import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

import { forkJoin } from 'rxjs';
import { finalize } from 'rxjs/operators';

import { LocalidadeService, TemposRppsService, ValidarRequiredFormService } from '@app/shared/services';
import { UtilService } from '@app/shared/services/util.service';

import { environment } from '@environments/environment';
import { Censo, ChaveValor, ConfigCamposFormulario, Loading, Municipio, TempoRPPS } from '@app/shared/models';
import { MensagemService } from '@app/shared/services/mensagem.service';
import { CensoService } from '@app/shared/services/censo.service';

@Component({
  selector: 'app-adicionar-tempo-rpps',
  templateUrl: './adicionar-tempo-rpps.component.html',
  styleUrls: ['./adicionar-tempo-rpps.component.scss']
})
export class AdicionarTempoRppsComponent {

  loading = new Loading();
  cliente = environment.cliente;
  form: FormGroup;
  tiposDependente: ChaveValor[] = [];

  estados: ChaveValor[] = [];
  todosMunicipios: Municipio[] = [];
  municipios: Municipio[] = [];
  carregar = new Loading();
  carregarMunicipios = new Loading();
  censo: Censo;

  configCamposFormulario: ConfigCamposFormulario[];

  constructor(
    public dialogRef: MatDialogRef<AdicionarTempoRppsComponent>,
    private fb: FormBuilder,
    private mensagemService: MensagemService,
    private localidadeService: LocalidadeService,
    private temposRppsService: TemposRppsService,
    private utilService: UtilService,
    private validarRequiredFormService: ValidarRequiredFormService,
    private censoService: CensoService,

    @Inject(MAT_DIALOG_DATA) public data: {
      tempo: TempoRPPS, listaTempos: TempoRPPS[], segurado: any, configCamposFormulario: ConfigCamposFormulario[]
    }
  ) {
    this.censo = this.censoService.retornarSessionStorage('censo');

    this.configCamposFormulario = data.configCamposFormulario;

    this.form = this.fb.group({
      id: [null],
      tipo: [null],
      numeroCTC: [null],
      dataEmissaoCTC: [null, [(control: AbstractControl) => this.utilService.validatorsCustomData(control)]],
      dataInicial: [null, [(control: AbstractControl) => this.utilService.validatorsCustomData(control)]],
      dataFinal: [null, [
        (control: AbstractControl) => this.utilService.validatorsCustomData(control),
        (control: AbstractControl) => this.utilService.verificarDataFimMaiorQueInicio(this.form?.value?.dataInicial, control.value),
      ]],
      cargo: [null],
      matricula: [null],
      idMunicipio: [null],
      idUf: [null]
    });

    this.definirValidatorRequiredNosCampos();

    this.obterUfs();

    if (data.tempo) {
      this.form.patchValue({
        ...data.tempo,
        idUf: data.tempo.municipio.uf.id,
        idMunicipio: data.tempo.municipio.id,
        dataEmissaoCTC: this.utilService.formatarDataBR(data.tempo.dataEmissaoCTC),
        dataInicial: this.utilService.formatarDataBR(data.tempo.dataInicial),
        dataFinal: this.utilService.formatarDataBR(data.tempo.dataFinal)
      });

      if (this.form.get('idUf').value) {
        this.lidarComUf(this.form.get('idUf').value);
      }
    }
  }

  lidarComUf(uf: any) {
    if (uf == 'null' || uf == null) {
      this.municipios = [];
      this.form.get('idUf').reset();
      this.form.get('idMunicipio').reset();
      return;
    }

    this.localidadeService.getMunicipios(uf, this.carregarMunicipios).subscribe(municipios => {
      this.municipios = municipios
      if (municipios.find(mun => mun.id == this.form.get('idMunicipio').value)) return;
      else this.form.get('idMunicipio').reset();
    });
  }

  obterUfs(): void {
    this.localidadeService.getEstados(this.carregar).subscribe(estados => this.estados = estados);
  }

  validar(): void {
    for (const c in this.form.controls) {
      if (this.form.controls[c]) {
        this.form.controls[c].markAsTouched();
      }
    }

    if (this.form.invalid) return this.mensagemService.avisoFormularioInvalido();

    (this.form.value.id) ? this.editar() : this.salvar();
  }

  editar(): void {
    this.temposRppsService.editarTempo(this.formSalvar, this.loading).subscribe(value => {
      this.dialogRef.close(value);
    });
  }

  salvar(): void {
    this.temposRppsService.cadastrarTempo(this.formSalvar, this.loading).subscribe(value => {
      this.dialogRef.close(value);
    });
  }
  definirValidatorRequiredNosCampos(): void {
    this.validarRequiredFormService.definirValidatorRequiredNosCampos(this.form, this.configCamposFormulario);
  }

  isRequired(campo: string): any {
    return this.utilService.isRequiredField(campo, this.form)
  }

  isVisible(campo: string): boolean {
    if (!this.configCamposFormulario) return null;

    const isVisible = this.configCamposFormulario.find((_: any) => _.nomeCampo == campo).visivel
    return isVisible;
  }

  get formSalvar(): TempoRPPS {
    return {
      ...this.form.value,
      dataEmissaoCTC: this.utilService.formatarDataPadraoHTML(this.form.get('dataEmissaoCTC').value),
      dataInicial: this.utilService.formatarDataPadraoHTML(this.form.get('dataInicial').value),
      dataFinal: this.utilService.formatarDataPadraoHTML(this.form.get('dataFinal').value)
    };
  }
}
